export const GET_TAGS_QUERY = `
  query GetTags($where: tags_bool_exp = {}) {
    tags(where: $where, order_by: { created_at: desc }) {
      id
      name
      tags_color
      tags_page
      company_id
      company {
        id
        name
      }
      created_at
      updated_at
    }
    tags_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_TAG_BY_ID_QUERY = `
  query GetTagById($id: Int!) {
    tags_by_pk(id: $id) {
      id
      name
      tags_color
      tags_page
      company_id
      company {
        id
        name
      }
      created_at
      updated_at
    }
  }
`;
